import * as React from "react";

import { TCity } from "utils/topBoard/types";

export interface ICityDef {
  id: TCity;
  nominativeTranslation: string;
  locativeTranslation: string;
  averageDiscount: number; // in CZK
  averageSoldOutTime: number; // in minutes
}

export default function useCitiesEnum() {
  return React.useMemo(
    (): Array<ICityDef> => [
      {
        id: "brno",
        nominativeTranslation: "Brno",
        locativeTranslation: "Brně",
        averageDiscount: 1748,
        averageSoldOutTime: 525,
      },
      {
        id: "praha",
        nominativeTranslation: "Praha",
        locativeTranslation: "Praze",
        averageDiscount: 2563,
        averageSoldOutTime: 410,
      },
    ],
    [],
  );
}
